<template>
  <div class="goods__recommend goodsRecommend" id="goodsRecommend">
    <div class="goods__recommend__header">
      商品推荐
    </div>
    <div class="goods__recommend__list">
      <GoodsInfo
        class="pointer"
        v-for="goods in goodsList"
        :key="goods.itemCode"
        :goods="goods"
        :itemStyle="itemStyle"
        :purchaseAble="true"
        @update-cart="updateCart"
        @click-goods="linkToGoodsDetails(goods.itemCode)"
      />
    </div>
    <div class="goods__recommend__more">
      <span v-if="hasMore" class="pointer" @click="$emit('load-more')">加载更多</span>
      <span v-else>没有更多了</span>
    </div>
  </div>
</template>

<script>
import GoodsInfo from '@/components/GoodsInfo';
export default {
  props: {
    goodsList: {
      type: Array,
      default: () => []
    },
    hasMore: {
      type: Boolean,
      default: true
    }
  },
  components: {
    GoodsInfo
  },
  inject: ['home'],
  data() {
    return {
      itemStyle: {
        margin: '0 6px 16px 6px',
        marginBottom: '16px',
        height: '450px',
      }
    };
  },
  methods: {
    updateCart() {
      // Telescope.trackEvent({
      //   trackId: 'zyb2bpc-event-ssy-ssjgydjjganB2B',
      // })
      // 加购成功获取购物车数量
      this.$emit('update-cart');
    },

    linkToGoodsDetails(id) {
      const search = this.home.$refs.search;
      search && search.clear();
      this.$router.push({ path: `/goodsDetails/${id}` });
    }
  }
};
</script>

<style lang="scss" scoped>
.goods__recommend {
  &__header {
    margin-top: 32px;
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: 500;
    color: #000000;
    line-height: 1;
  }
  &__list {
    display: flex;
    flex-wrap: wrap;
  }
  &__more {
    margin: 32px 0;
    font-size: 18px;
    font-weight: 400;
    color: #595959;
    text-align: center;
  }
}
</style>
